import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TreeNode} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {BwEtree, BwEtreeService, BwSchedule, BwScheduleService} from '../../generated';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import * as _ from 'lodash';
import {Schedule} from '../../models/Schedule';
import {Etree} from '../../models/Etree';
import {BaseClientComponent} from '../base-client.component';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {SelectItem} from '../../models/select-item';
import {EtreeService} from '../../services/etree.service';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';
import moment from 'moment';
import {BwJiraIssue} from '../../models/BwJiraIssue';
import {JiraPopOption, JiraService} from 'src/app/services/jira.service';
import {Company} from '../../models/company';
import {UserLogged} from '../../models/userLogged';
import {forkJoin, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

const SCHEDULE_TERMINATED = 'terminated';

@Component({
  selector: 'app-bw-schedules',
  templateUrl: './bw-schedules.component.html',
  styleUrls: ['./bw-schedules.component.css']
})
export class BwSchedulesComponent extends BaseClientComponent implements OnInit, OnDestroy {
  bwmUrl = environment.bwmUrl;
  clfProductId = environment.clfProductId;
  currentCompany: Company;
  loggedInUser: UserLogged;
  schedules: Array<Schedule> = [];
  originalSchedules: Array<Schedule> = [];
  searchForm: UntypedFormGroup;
  etreeSelectItemsForJira: SelectItem[] = [];
  productsSelectItemsForJira: SelectItem[] = [];
  crossConnectItemForJira: SelectItem[] = [];
  popsItemForJira: JiraPopOption[] = [];
  formSelectValuesBundles: SelectItem[] = [];
  formSelectValueAccounts: SelectItem[] = [];
  tableItemsPaginationRows = 10;
  selectedItem = [];
  statusItems: SelectItem[] = [];
  businessUnitsList: SelectItem[] = [];
  isJirapopUp = false;
  displayEtreeDropDown = false;
  displayPopDropDown = false;
  displayXcoDropDown = false;
  loading = true;
  displayAllConnectionList = false;
  allConnections: any = {
    etrees: [],
    receptionPoints: [],
    accountName: null
  };
  createdJiraIssues: { code: string, link: string }[] = [];
  isSendToJiraDisabled = false;
  etreeDeprovisionedStatus = 'deprovisioned';
  methods = ['lcm', 'mbel'];
  cols: any[];
  displayJiraFeature: boolean;
  userChoicesFiltersDefaultSchedules = {
    bundleId: null,
    accountId: null,
    contractReferences: null,
    crossConnects: null,
    sps: null,
    mbel: null,
    ad: null,
    status: Array<SelectItem>(),
    businessUnit: Array<SelectItem>()
  };
  error = false;
  jiraCreationError = false;
  userChoicesActiveFiltersSchedules = _.clone(this.userChoicesFiltersDefaultSchedules);
  @ViewChild('dataTableSchedules') dataTableSchedules: any;
  @ViewChild('dataTableAllConnections') dataTableAllConnections: any;
  accountTreeNodes: TreeNode[] = [];
  selectedAccountNodes: TreeNode[] = [];
  selectedAccountName: string;
  selectedConnections: any;
  allConnectionsCols: any[];
  filterActive = false;
  etreesById: any;
  selectedContractingAccountIds: string[];
  selectedCompanyId: string;
  selectedCompany: SelectItem;
  selectedStautsList: string[];
  selectedBusinessUnitsList: string[];
  jiraCustomDescription = '';
  selectedEtreesForJira: any;
  selectedProdutsForJira: any;
  selectedXcoForJira: any;
  selectedPopsForJira: any;
  bwJiraIssue: BwJiraIssue = new BwJiraIssue();
  selectedPriority = 'support';
  successCreateJira = false;
  popSwitchStates: boolean[] = [];
  selectedParticipantForJira: any;
  particpantsItemForJira: any[];

  constructor(
    public route: ActivatedRoute,
    public bwScheduleService: BwScheduleService,
    public bwEtreeService: BwEtreeService,
    public etreeService: EtreeService,
    public datePipe: DatePipe,
    private _route: ActivatedRoute,
    private _router: Router,
    private _formBuilder: UntypedFormBuilder,
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected http: HttpClient,
    private jiraService: JiraService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
    this.cols = [
      {field: 'name', header: 'Name', sortDisabled: false, class: ''},
      {field: 'contractReference', header: 'E-Tree ID', sortDisabled: false, class: ''},
      {field: 'clientReference', header: 'Client reference', sortDisabled: false, class: ''},
      {field: 'injectionPointXco', header: 'Inject cross connect', sortDisabled: false, class: ''},
      {field: 'bandwidth', header: 'Contractual bandwidth', sortDisabled: false, class: ''},
      {field: 'injectionPoint', header: 'Injection POP', sortDisabled: false, class: ''},
      {field: 'receptionPoints', header: 'Listen POPs', sortDisabled: false, class: ''},
      {field: 'acceptanceDate', header: 'Acceptance date', sortDisabled: false, class: ''},
      {field: 'deprovisionedDate', header: 'deprovisioned date', sortDisabled: false, class: ''},
      {field: 'option', header: 'Option', sortDisabled: false, class: ''},
    ];
    this.allConnectionsCols = [
      {field: 'etreeId', header: 'Etree ID'},
      {field: 'etreeInjectionPop', header: 'Injection'},
      {field: 'etreeBandWidth', header: 'Reception'}
    ];
  }

  ngOnInit() {
    this.displayJiraFeature = environment.displayJiraFeature;
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
      this.iniSearchForm();
    });
    this.userChoicesActiveFiltersSchedules = this.utilsService.loadUserPref('bwScheduleFilter', this.userChoicesFiltersDefaultSchedules);
    this.subscriptions.push(response$);
  }

  public ngOnChanges() {
    this.loggedInUser = this.authenticationService.userCurrent;
    this.currentCompany = this.loggedInUser.company;
    // avoid reload when route change only for anchors:
    this._route.paramMap.subscribe(params => {
      if (params.get('companySugarUuid')) {
        this.selectedCompanyId = params.get('companySugarUuid');
      }
    });
    forkJoin([
      this.bwScheduleService.getBwScheduleCollection(),
      this.bwEtreeService.clientRefsBwEtreeCollection()
    ]).subscribe((result) => {
      this.etreesById = _.keyBy(result[1], 'id');
      this.prepareSchedulesList(result[0]);
      this.setStatusList();
      this.setBusinessUnitList();
      this.originalSchedules = this.schedules;
      this.loading = false;
      this.changeDetectorRef.detectChanges();
      this.onAccountSelectionChange();
      this.utilsService.unlockUi();
    });
  }

  capitalize(list: any[], key: string) {
    return list.map((item) => {
      item[key] = item[key].charAt(0).toUpperCase() + item[key].slice(1);
      return item;
    });
  }

  setStatusList() {
    this.statusItems = this.schedules.map(schedule => ({
      label: schedule.status.replace(/_/g, ' '),
      value: schedule.status
    } as SelectItem));
    this.statusItems = this.statusItems.filter(
      (item, index, self) => self.findIndex(i => i.value.toLowerCase() === item.value.toLowerCase()) === index);
    this.statusItems = this.capitalize(this.statusItems, 'label');
    this.statusItems.sort((selectItem1, selectItem2) => {
      if (selectItem1.label.toLowerCase() < selectItem2.label.toLowerCase()) {
        return -1;
      }
      if (selectItem1.label.toLowerCase() > selectItem2.label.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  setBusinessUnitList() {
    const seen = new Set<string>();
    this.businessUnitsList = [];
    this.schedules.forEach(schedule => {
      const uuid = schedule.billingAccountId;
      if (!uuid) {
        return;
      }
      let name = schedule.billinggAccountName;
      if (!name) {
        name = schedule.billingAccountId + '?';
      }
      if (!seen.has(uuid)) {
        seen.add(uuid);
        this.businessUnitsList.push({
          label: name,
          value: uuid
        } as SelectItem);
      }
    });
    this.businessUnitsList.sort((a, b) =>
      a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    );
  }

  public onClickedResetFilter() {
    this.utilsService.saveUserData('bwScheduleFilter', this.userChoicesFiltersDefaultSchedules);
    this.selectedAccountNodes = [];
    this.selectedContractingAccountIds = [];
    this.selectedStautsList = [];
    this.selectedBusinessUnitsList = [];
    this.userChoicesActiveFiltersSchedules.status = [];
    this.userChoicesActiveFiltersSchedules.bundleId = null;
    this.userChoicesActiveFiltersSchedules.crossConnects = null;
    this.userChoicesActiveFiltersSchedules.contractReferences = null;
    this.userChoicesActiveFiltersSchedules.businessUnit = [];
    this.userChoicesActiveFiltersSchedules = _.clone(this.userChoicesFiltersDefaultSchedules);
    this.filterActive = false;
    this.applyFiltersOnDataTableItem();
  }

  public getDateString(date: string) {
    if (!date) {
      return '-';
    }
    return moment.utc(date).format('YYYY/MM/DD');
  }

  public applyFiltersOnDataTableItem() {
    this.utilsService.saveUserData('bwScheduleFilter',
      {
        'bundleId': this.userChoicesActiveFiltersSchedules.bundleId,
        'accountId': this.userChoicesActiveFiltersSchedules.accountId,
        'contractReferences': this.userChoicesActiveFiltersSchedules.contractReferences,
        'crossConnects': this.userChoicesActiveFiltersSchedules.crossConnects,
        'sps': this.userChoicesActiveFiltersSchedules.sps,
        'mbel': this.userChoicesActiveFiltersSchedules.mbel,
        'ad': this.userChoicesActiveFiltersSchedules.ad,
        'status': this.userChoicesActiveFiltersSchedules.status,
        'businessUnit': this.userChoicesActiveFiltersSchedules.businessUnit,
      });

    this.filterActive = !!(this.userChoicesActiveFiltersSchedules.contractReferences
      || this.userChoicesActiveFiltersSchedules.crossConnects
      || this.userChoicesActiveFiltersSchedules.sps === true
      || this.userChoicesActiveFiltersSchedules.mbel === true
      || this.userChoicesActiveFiltersSchedules.ad === true
      || this.userChoicesActiveFiltersSchedules.status
      || this.userChoicesActiveFiltersSchedules.businessUnit
      || this.userChoicesActiveFiltersSchedules.accountId);
    if (this.dataTableSchedules) {
      this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.bundleId, 'bundleId', 'equals');
      this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.contractReferences, 'contractReferences', 'contains');
      this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.crossConnects, 'crossConnects', 'contains');
      this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.status, 'status', 'in');
      this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.businessUnit, 'billingAccountId', 'in');
      if (this.userChoicesActiveFiltersSchedules.sps === true) {
        this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.sps, 'sps', 'equals');
      } else {
        this.dataTableSchedules.filter([true, false], 'sps', 'in');
      }
      if (this.userChoicesActiveFiltersSchedules.mbel === true) {
        this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.mbel, 'mbel', 'equals');
      } else {
        this.dataTableSchedules.filter([true, false], 'mbel', 'in');
      }
      if (this.userChoicesActiveFiltersSchedules.ad === true) {
        this.dataTableSchedules.filter(this.userChoicesActiveFiltersSchedules.ad, 'ad', 'equals');
      } else {
        this.dataTableSchedules.filter([true, false], 'ad', 'in');
      }
      if (this.loggedInUser.permissions.isMckayAdminOrMckaySuper === true) {
        this.dataTableSchedules.filter(this.selectedContractingAccountIds, 'contractingAccountId', 'in');
      }
      this.schedules.map((schedule: Schedule) => {
        if (!this.productsSelectItemsForJira.some(item => item.value.bundleName === schedule.bundleName)) {
          this.productsSelectItemsForJira.push({label: schedule.bundleName, value: schedule});
        }
        schedule.etrees.map((etree: Etree) => {
          if (this.filterActive === false) {
            etree.visibleOnfilters = true;
          } else {
            // contract reference
            let etreeXcoString = null;
            // @ts-ignore
            if (etree.injectionPoint && etree.injectionPoint.ccps && etree.injectionPoint.ccps.xcos) {          // @ts-ignore
              // @ts-ignore
              etreeXcoString = _.toArray(etree.injectionPoint.ccps.xcos).join(',');
              // @ts-ignore
            }
            etree.visibleOnfilters = (!(this.userChoicesActiveFiltersSchedules.contractReferences) || etree.contractReference.indexOf(this.userChoicesActiveFiltersSchedules.contractReferences) !== -1)
              && (!(this.userChoicesActiveFiltersSchedules.crossConnects) || (etreeXcoString && etreeXcoString.indexOf(this.userChoicesActiveFiltersSchedules.crossConnects) !== -1))
              && (!(this.userChoicesActiveFiltersSchedules.mbel) || (etree.isMbelEligible === true))
              && (!(this.userChoicesActiveFiltersSchedules.sps) || (etree.spsEligible === true))
              && (!(this.userChoicesActiveFiltersSchedules.ad) || (etree.activeDiversity === true));
          }
        });
      });
      this.productsSelectItemsForJira.sort((a, b) => a.label.localeCompare(b.label));
    }
  }

  formatArray(input: Array<string>) {
    if (input) {
      return input.join(', ');
    } else {
      return '-';
    }
  }

  public openAllConnectionsList() {
    this.allConnections = null;
    let schedules = [];
    if (this.loggedInUser.permissions.isMckaySuper && this.selectedContractingAccountIds) {
      const selectedContractingAccountIds = this.selectedContractingAccountIds;
      schedules = this.schedules.filter(function (schedule) {
        return selectedContractingAccountIds.includes(schedule.contractingAccountId) ||
          selectedContractingAccountIds.includes(schedule.accountId);
      });
    } else {
      schedules = this.schedules;
    }
    if (schedules.length) {
      this.selectedAccountName = schedules[0].accountName;
      this.allConnections = {
        etrees: [],
        receptionPoints: [],
        accountName: this.loggedInUser.permissions.isMckayUser ? '' : this.selectedAccountName
      };
      _.forEach(schedules, (schedule: Schedule) => {
        if (schedule.activeEtrees) {
          _.forEach(schedule.etrees, (etree: Etree) => {
            const data = {};
            if (schedule.name) {
              data['companyName'] = schedule.name;
            }
            if (etree['hideOnPortal']) {
              return;
            }
            data['etreeId'] = etree['contractReference'];
            data['etreeBandwidthProduct'] = schedule.bundleName;
            data['etreeInjectionPop'] = etree.activeEtreeInjectionDemarcationPoint
            && etree.activeEtreeInjectionDemarcationPoint.popShortName ? etree.activeEtreeInjectionDemarcationPoint.popShortName : '-';
            // @ts-ignore
            data['etreeBandWidth'] = (etree.bandwidth) ? etree.bandwidth : '-';
            data['injectionCcp'] = {
              id: etree.activeEtreeInjectionDemarcationPoint ? etree.activeEtreeInjectionDemarcationPoint.id : null,
            };
            data['receptionPointsData'] = [];
            data['receptionPoints'] = [];
            data['rowSpan'] = 0;
            data['firstInjectionMethod'] = null;
            data['otherInjectionMethods'] = [];
            this.allConnections.receptionPoints = _.concat(this.allConnections.receptionPoints, etree.receptionPoints);
            if (etree.activeEtreeInjectionDemarcationPoint) {
              const idp = etree.activeEtreeInjectionDemarcationPoint;
              if (idp.activeClientConnectionPoints) {
                _.forEach(idp.activeClientConnectionPoints, (ccpIdp) => {
                  if (!data['injectionCcp'][ccpIdp['mbelAllocation']]) {
                    data['injectionCcp'][ccpIdp['mbelAllocation']] = {};
                  }
                  if (!data['firstInjectionMethod']) {
                    data['firstInjectionMethod'] = ccpIdp['mbelAllocation'];
                    data['rowSpan']++;
                  } else {
                    data['otherInjectionMethods'].push(ccpIdp['mbelAllocation']);
                    data['rowSpan']++;
                  }
                  if (ccpIdp['mbelAllocation'] !== 'MBEL') {
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['xco'] = ccpIdp['crossConnectId'];
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['bandwidth'] = ccpIdp['bwAllocation'];
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['tag'] = ccpIdp['taggedFrames'] ? 'VLAN: ' + ccpIdp['clientVlan'] : '';
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['label'] = ccpIdp['label'] ? ccpIdp['label'] : '-';
                  }
                  if (ccpIdp['mbelAllocation'] === 'MBEL') {
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['xco'] = ccpIdp['crossConnectId'];
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['bandwidth'] = ccpIdp['bwAllocation'];
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['tag'] = 'HK: ' + ccpIdp['mbelHeaderKey'];
                    data['injectionCcp'][ccpIdp['mbelAllocation']]['label'] = ccpIdp['label'] ? ccpIdp['label'] : '-';
                  }
                });
              }

            }
            if (etree.etreeReceptionDemarcationPoints) {
              _.forEach(etree.etreeReceptionDemarcationPoints, (rdp) => {
                const rdpData = {
                  pop: rdp.popShortName,

                };
                _.forEach(rdp.activeClientConnectionPoints, (ccpRdp) => {
                  if (!rdpData[ccpRdp['mbelAllocation']]) {
                    rdpData[ccpRdp['mbelAllocation']] = {};
                  }
                  if (ccpRdp['mbelAllocation'] !== 'MBEL') {
                    rdpData[ccpRdp['mbelAllocation']]['xco'] = ccpRdp['crossConnectId'];
                    rdpData[ccpRdp['mbelAllocation']]['bandwidth'] = ccpRdp['bwAllocation'];
                    rdpData[ccpRdp['mbelAllocation']]['tag'] = ccpRdp['taggedFrames'] ? 'VLAN: ' + ccpRdp['clientVlan'] : '';
                    rdpData[ccpRdp['mbelAllocation']]['label'] = ccpRdp['label'] ? ccpRdp['label'] : '-';
                  } else if (ccpRdp['mbelAllocation'] === 'MBEL') {
                    rdpData[ccpRdp['mbelAllocation']]['xco'] = ccpRdp['crossConnectId'];
                    rdpData[ccpRdp['mbelAllocation']]['bandwidth'] = ccpRdp['bwAllocation'];
                    rdpData[ccpRdp['mbelAllocation']]['tag'] = 'HK: ' + ccpRdp['mbelHeaderKey'];
                    rdpData[ccpRdp['mbelAllocation']]['label'] = ccpRdp['label'] ? ccpRdp['label'] : '-';
                  }
                });
                data['receptionPointsData'].push(rdpData);
              });
            }
            this.allConnections.etrees.push(data);
          });
        }
      });
      this.allConnections.receptionPoints = _.uniq(this.allConnections.receptionPoints);
      this.allConnections.etrees = _.sortBy(this.allConnections.etrees, ['etreeBandwidthProduct']);
      this.displayAllConnectionList = true;
    }
  }

  exportAllConnection() {
    const url = environment.baseUrlWs + '/api/bw-profile/export-all-connections';
    this.http.post(url, this.allConnections, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }).subscribe({
        next: success => {
          const fileMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = this.b64toBlob(success['file_content'], fileMimeType, null);
          saveAs(blob, success['file_name']);
        },
        error: error => {
          this.utilsService.handleErrorWebservice$(error);
        }
      }
    );
  }

  exportEtreeJsonData(selectedEtree: Etree) {
    this.etreeService.exportEtreeJsonData(selectedEtree.id).subscribe({
      next: response => {
        const blob = new Blob([response], {type: 'application/json'});
        saveAs(blob, this.etreeService.getFileNameForExportJson(selectedEtree));
      },
      error: () => {
        this.error = true;
      }
    });
  }

  onAccountSelectionChange() {
    for (const parent of this.accountTreeNodes) {
      if (!parent.children?.length) {
        continue;
      }
      const parentSelected = this.selectedAccountNodes.some(n => n.key === parent.key);
      if (parentSelected) {
        const allChildrenSelected = parent.children.every(
          child => this.selectedAccountNodes.some(n => n.key === child.key)
        );
        if (!allChildrenSelected) {
          this.selectedAccountNodes = this.selectedAccountNodes.filter(n => n.key !== parent.key);
        }
      }
    }
    this.selectedContractingAccountIds = [];
    for (const node of this.selectedAccountNodes) {
      this.selectedContractingAccountIds.push(node.data);
    }
    this.applyFiltersOnDataTableItem();
  }

  isAllAccountsSelected(): boolean {
    if (!this.accountTreeNodes.length) {
      return false;
    }
    let totalLeaves = 0;
    for (const parent of this.accountTreeNodes) {
      totalLeaves += parent.children?.length || 1;
    }
    const selectedLeaves = this.selectedAccountNodes.filter(n => !n.children?.length).length;
    return selectedLeaves > 0 && selectedLeaves >= totalLeaves;
  }

  toggleAllAccounts(event: any) {
    if (event.checked) {
      this.selectedAccountNodes = [];
      for (const parent of this.accountTreeNodes) {
        this.selectedAccountNodes.push(parent);
        if (parent.children?.length) {
          parent.children.forEach(child => this.selectedAccountNodes.push(child));
        }
      }
    } else {
      this.selectedAccountNodes = [];
    }
    this.onAccountSelectionChange();
  }

  exportAllEtreesAsJson() {
    this.etreeService.exportAllEtreesJsonData().subscribe({
      next: response => {
        const blob = new Blob([response], {type: 'application/json'});
        saveAs(blob, this.formatToday() + '-Etrees-Description.json');
      },
      error: () => {
        this.error = true;
      }
    });
  }

  gotoAnnoucementPage(etree) {
    if (!etree.announcementMessages) {
      return;
    }
    const userChoicesFiltersDefaultAnnouncementLog = {
      'subject': null,
      'message': null,
      'fromMail': null,
      'user': null,
      'sentDateFrom': null,
      'sentDateTo': null,
      'uuid': null,
    };
    const userChoicesActiveFilters = this.utilsService.loadUserPref('announcementLogFilter', userChoicesFiltersDefaultAnnouncementLog);
    userChoicesActiveFilters.uuid = etree.announcementMessages;
    this.utilsService.saveUserData('announcementLogFilter', userChoicesActiveFilters);
    this._router.navigate(['/' + this.loggedInUser.company.uniqid + '/announcementLog']);
  }

  getEtreeRowClass(etree: BwEtree) {
    if (!etree.onGoingAnnouncement) {
      return '';
    }
    return (etree.onGoingOutage === true) ? 'ongoingoutage' : 'ongoingannouncement';

  }

  openSendJiraPopup() {
    if (!this.loggedInUser.permissions.isMckayUser) {
      this.prepareData();
    }
    this.isJirapopUp = true;
  }

  disableCreateIssueButton() {
    if (!this.jiraCustomDescription || this.jiraCustomDescription.length === 0) {
      return true;
    }
    return (!this.selectedProdutsForJira || this.selectedProdutsForJira.length === 0)
      || ((!this.selectedEtreesForJira || this.selectedEtreesForJira.length === 0))
      || (!this.selectedPopsForJira || this.selectedPopsForJira.length === 0);
  }

  createIssue() {
    if (this.disableCreateIssueButton()) {
      this.isSendToJiraDisabled = true;
      return;
    }
    this.isSendToJiraDisabled = false;
    this.bwJiraIssue.reporter = this.loggedInUser;
    this.bwJiraIssue.createdBy = this.loggedInUser.username;
    this.bwJiraIssue.isSupport = this.selectedPriority === 'support';

    const contractReferences = this.selectedEtreesForJira.map(etree => etree.contractReference);
    const requests = this.selectedProdutsForJira.map((schedule: Schedule) => {
      const issueText = this.jiraService.buildBwIssueText(
        schedule.bundleName,
        contractReferences,
        this.popsItemForJira,
        this.selectedPopsForJira,
        this.selectedXcoForJira,
        this.jiraCustomDescription
      );
      return this.jiraService.createJiraIssue({
        description: issueText.description,
        subject: issueText.subject,
        participantEmail: this.selectedParticipantForJira,
        createdByUserName: this.bwJiraIssue.reporter.username,
        createdByEmail: this.bwJiraIssue.reporter.email,
        isSupport: this.bwJiraIssue.isSupport,
        isMckayProject: true,
        isQuincyProject: false,
      }).pipe(catchError(() => of(null)));
    });

    if (requests.length === 0) {
      return;
    }
    this.utilsService.lockUi();
    forkJoin(requests).subscribe((responses: any[]) => {
      this.createdJiraIssues = responses
        .filter(response => response !== null)
        .map(response => ({code: response['created_issue_key'], link: response['jira_link']}));
      this.successCreateJira = this.createdJiraIssues.length > 0;
      this.jiraCreationError = this.createdJiraIssues.length < responses.length;
      this.isJirapopUp = false;
      this.cancel();
      this.utilsService.unlockUi();
    });
  }

  groupEtreesBySelectedPops() {
    const groupedEtrees: { [pop: string]: any[] } = {};
    this.selectedPopsForJira.forEach(pop => {
      const matchingPops = this.popsItemForJira.filter(popItem => popItem.value === pop);
      matchingPops.forEach(popItem => {
        const etree = this.selectedEtreesForJira.find(etree => etree.id === popItem.id);
        if (etree) {
          if (!groupedEtrees[popItem.value]) {
            groupedEtrees[popItem.value] = [];
          }
          groupedEtrees[popItem.value].push(etree);
        }
      });
    });
    return groupedEtrees;
  }

  cancel() {
    this.isJirapopUp = false;
    this.jiraCustomDescription = '';
    this.selectedEtreesForJira = [];
    this.selectedPopsForJira = [];
    this.selectedProdutsForJira = [];
    this.selectedXcoForJira = [];
    this.displayEtreeDropDown = false;
    this.displayPopDropDown = false;
    this.displayXcoDropDown = false;
    this.jiraCustomDescription = null;
  }

  onSelectProductsUpdateValues() {
    if (this.selectedProdutsForJira.length === 0) {
      // Clearing all the old selections if no products are selected
      this.selectedEtreesForJira = [];
      this.displayEtreeDropDown = false;
      this.selectedPopsForJira = [];
      this.displayPopDropDown = false;
      this.selectedXcoForJira = [];
      this.crossConnectItemForJira = [];
      return;
    }
    // avoid setting duplicated values in etree list
    const newEtreeSet = new Set<string>();
    this.selectedProdutsForJira.forEach((schedule: Schedule) => {
      schedule.etrees.forEach((e: Etree) => {
        newEtreeSet.add(e.name);
      });
    });
    //setting or re-setting etree list and etree selected list
    this.etreeSelectItemsForJira = this.etreeSelectItemsForJira.filter(item =>
      newEtreeSet.has(item.label)
    );
    if (!this.selectedEtreesForJira) {
      this.selectedEtreesForJira = [];
    }
    this.selectedEtreesForJira = this.selectedEtreesForJira.filter(etree =>
      newEtreeSet.has(etree.name)
    );
    this.selectedProdutsForJira.forEach((schedule: Schedule) => {
      schedule.etrees.forEach((e: Etree) => {
        if (!this.etreeSelectItemsForJira.some(item => item.label === e.name)) {
          this.etreeSelectItemsForJira.push({label: e.name, value: e});
        }
      });
    });
    this.etreeSelectItemsForJira.sort((a, b) => a.label.localeCompare(b.label));
    this.displayEtreeDropDown = this.etreeSelectItemsForJira.length > 0;
    // calling on select Etree to update pop and Xco selection and drop down items
    this.onSelectEtreesUpdateValues();
  }

  onSelectEtreesUpdateValues() {
    this.displayPopDropDown = this.selectedEtreesForJira.length > 0;
    this.isSendToJiraDisabled = false;
    if (this.selectedEtreesForJira.length === 0) {
      // Clear  all  the old selections if thers is no more etrees selected
      this.selectedPopsForJira = [];
      this.popsItemForJira = [];
      this.crossConnectItemForJira = [];
      this.displayXcoDropDown = false;
      this.displayPopDropDown = false;
      return;
    }
    const allPops = new Map<string, JiraPopOption>();
    this.popsItemForJira = [];
    this.selectedEtreesForJira.forEach(etree => {
      let injectionPops: string[] = [];
      let receptionPops: string[] = [];

      if (etree.injectionPoint['ccps'] && etree.injectionPoint['ccps']['pops']) {
        injectionPops = _.flatMap(Object.values(etree.injectionPoint['ccps']['pops']));
      } else if (etree.injectionPoint['pop']) {
        injectionPops = [etree.injectionPoint['pop']];
      }
      if (etree.receptionPoints && etree.receptionPoints.length > 0) {
        receptionPops = etree.receptionPoints;
      }
      if (injectionPops && injectionPops.length > 0) {
        const injectionLabel = `${injectionPops.join(',')} (Inj)`;
        allPops.set(injectionLabel, {label: injectionLabel, value: injectionLabel, kind: 'injection', id: etree.id});
      }
      if (receptionPops && receptionPops.length > 0) {
        const receptionLabel = `${receptionPops.join(',')} (Listen)`;
        allPops.set(receptionLabel, {label: receptionLabel, value: receptionLabel, kind: 'reception', id: etree.id});
      }
    });
    this.setXcoSelectItems();
    this.popsItemForJira = Array.from(allPops.values());
    if (this.selectedPopsForJira) {
      this.selectedPopsForJira = this.selectedPopsForJira.filter(pop =>
        this.popsItemForJira.some(item => item.value === pop)
      );
    }
  }

  setXcoSelectItems() {
    const uniqueXcosInjectionsValuesSet = new Set<string>(
      this.selectedEtreesForJira.flatMap(etree => {
        if (etree.injectionPoint.ccps && Object.keys(etree.injectionPoint.ccps).length > 0) {
          return _.flatMap(Object.values(etree.injectionPoint.ccps.xcos));
        } else {
          return [];
        }
      })
    );
    // setting and resetting xco depends on selected or deseclted etrees
    const uniqueXcosRecptionValuesSet = new Set<string>(this.selectedEtreesForJira.flatMap(etree => this.extractReceptionCrossConnect(etree)));
    const combinedUniqueValuesSet = new Set<string>([...uniqueXcosInjectionsValuesSet, ...uniqueXcosRecptionValuesSet]);
    const crossConnectItemForJira = Array.from(combinedUniqueValuesSet).map(value => {
      const e = this.selectedEtreesForJira.find(etree => {
        if (etree.injectionPoint && etree.injectionPoint.ccps.length > 0) {
          const xcos = _.flatMap(Object.values(etree.injectionPoint.ccps.xcos));
          return xcos.includes(value);
        }
        return false;
      });
      return {
        label: value,
        value: value,
        id: e ? e.id : null
      };
    });
    this.crossConnectItemForJira = crossConnectItemForJira
      .filter(xco => xco.label.length !== 0 || xco.value !== null || xco.id != null)
      .sort((a, b) => a.label.localeCompare(b.label));
    if (this.selectedXcoForJira && this.selectedXcoForJira.length > 0) {
      const newSelectedXcoForJira = [];
      this.selectedXcoForJira.forEach(etree => {
        if (this.crossConnectItemForJira.filter(xcoItem => xcoItem.label === etree).length > 0) {
          newSelectedXcoForJira.push(etree);
        }
      });
      this.selectedXcoForJira = newSelectedXcoForJira;
    }
  }

  onSelectPop() {
    this.isSendToJiraDisabled = false;
  }

  extractReceptionCrossConnect(etree) {
    const crossConnectIds = [];
    if (etree.etreeReceptionDemarcationPoints != null) {
      etree.etreeReceptionDemarcationPoints.forEach((rdp) => {
        rdp.activeClientConnectionPoints.forEach((ccpRdp) => {
          crossConnectIds.push(ccpRdp.crossConnectId);
        });
      });
    }
    return crossConnectIds;
  }

  onPopSwitchChange(i: number, event: any) {
    this.popSwitchStates[i] = event.checked;
    this.displayXcoDropDown = this.popSwitchStates.some(state => state);
  }

  setIsSendToJiraFlag() {
    this.isSendToJiraDisabled = false;
  }

  private iniSearchForm() {
    this.searchForm = this._formBuilder.group({
      bundle: [''],
      contractReference: [''],
    });
  }

  private prepareSchedulesList(schedules) {
    this.schedules = [];
    _.forEach(schedules['member'], (schedule: BwSchedule) => {
      if (schedule.status !== 'deleted') {
        const tmpSchedule = this.processBwSchedule(schedule);
        if (tmpSchedule !== undefined) {
          tmpSchedule.status = tmpSchedule.status ? tmpSchedule.status.toLowerCase() : '';
          this.schedules.push(tmpSchedule);
        }
      }
    });
    this.formSelectValuesBundles = _.uniqBy(this.formSelectValuesBundles, function (e) {
      return e.value;
    });
    this.schedules = _.sortBy(this.schedules, ['contractingAccountName']);
    this.formSelectValuesBundles = _.sortBy(this.formSelectValuesBundles, ['label']);

    this.formSelectValueAccounts = _.uniqBy(this.formSelectValueAccounts, function (e) {
      return e.value;
    });
    this.formSelectValueAccounts = _.sortBy(this.formSelectValueAccounts, ['label']);
    this.buildAccountTreeNodes();
  }

  private buildAccountTreeNodes() {
    this.accountTreeNodes = this.formSelectValueAccounts.map(account => {
      const children: TreeNode[] = account.value.childOptions.map(child => ({
        key: child.value,
        label: child.label,
        data: child.value
      })).sort((a, b) => a.label.localeCompare(b.label));
      const node: TreeNode = {
        key: account.value.id,
        label: account.label,
        data: account.value.id,
        expanded: true,
        children
      };
      return node;
    });
    this.preselectAccountNodes();
  }

  private preselectAccountNodes() {
    this.selectedAccountNodes = [];
    if (!this.selectedCompanyId) {
      return;
    }
    for (const parent of this.accountTreeNodes) {
      if (parent.data === this.selectedCompanyId) {
        if (parent.children?.length) {
          parent.children.forEach(child => this.selectedAccountNodes.push(child));
          this.selectedAccountNodes.push(parent);
        } else {
          this.selectedAccountNodes.push(parent);
        }
        break;
      }
    }
  }

  private processBwSchedule(schedule: BwSchedule): Schedule | undefined {
    const parsedScheduleData = JSON.parse(schedule.jsonData) as Schedule;
    parsedScheduleData.mbel = false;
    parsedScheduleData.sps = false;
    parsedScheduleData.ad = false;
    parsedScheduleData.contractReferences = [];
    parsedScheduleData.crossConnects = [];
    parsedScheduleData.etrees = [];
    if (parsedScheduleData.status === SCHEDULE_TERMINATED) {
      return undefined;
    }
    if (parsedScheduleData.activeEtrees) {
      _.forEach(parsedScheduleData.activeEtrees, (etree) => {
        if (etree['status'] !== this.etreeDeprovisionedStatus) {
          if ((this.loggedInUser && this.loggedInUser.permissions.isMckayUser) || (this.loggedInUser && !this.loggedInUser.permissions.isMckayUser && !etree['hideOnPortal'])) {
            const bwetree = _.toPlainObject(etree) as Etree;
            bwetree.visibleOnfilters = true;
            bwetree.clientReference = (this.etreesById[etree.id]) ? this.etreesById[etree.id].clientReference : etree.clientReference;
            bwetree.onGoingAnnouncement = (this.etreesById[etree.id]) ? this.etreesById[etree.id].onGoingAnnouncement : null;
            bwetree.onGoingOutage = (this.etreesById[etree.id]) ? this.etreesById[etree.id].onGoingOutage : null;
            bwetree.onGoingMaintenance = (this.etreesById[etree.id]) ? this.etreesById[etree.id].onGoingMaintenance : null;
            bwetree.announcementMessages = (this.etreesById[etree.id]) ? this.etreesById[etree.id].announcementMessages : [];
            bwetree.announcementCategory = (this.etreesById[etree.id]) ? this.etreesById[etree.id].announcementCategory : null;
            bwetree.serviceTypeShort = (this.etreesById[etree.id]) ? this.etreesById[etree.id].serviceTypeShort : null;
            parsedScheduleData.etrees.push(bwetree);
            parsedScheduleData.contractReferences.push(etree.contractReference);
            if (etree.spsEligible === true) {
              parsedScheduleData.sps = true;
            }
            if (etree.isMbelEligible === true) {
              parsedScheduleData.mbel = true;
            }
            if (etree.activeDiversity === true) {
              parsedScheduleData.ad = true;
            }

            if (etree.injectionPoint && etree.injectionPoint.ccps && etree.injectionPoint.ccps.xcos) {
              _.forEach(etree.injectionPoint.ccps.xcos, (xco) => {
                parsedScheduleData.crossConnects.push(xco);
              });
            }
          }
        }
      });
    }
    this.formSelectValuesBundles.push({
      label: parsedScheduleData.bundleName,
      value: parsedScheduleData.bundleId
    });
    const i = this.formSelectValueAccounts.findIndex(x => x.value.id === parsedScheduleData.accountId);
    if (i === -1) {
      this.formSelectValueAccounts.push({
        label: parsedScheduleData.accountName,
        value: {
          id: parsedScheduleData.accountId,
          childOptions: [],
          selectedChildOptions: []
        }
      });
    }
    const j = this.formSelectValueAccounts.findIndex(x => x.value.id === parsedScheduleData.accountId);
    if (parsedScheduleData.accountId !== parsedScheduleData.contractingAccountId) {
      const k = this.formSelectValueAccounts[j].value.childOptions.findIndex(x => x.value
        === parsedScheduleData.contractingAccountId);
      if (k === -1) {
        this.formSelectValueAccounts[j].value.childOptions.push({
          label: parsedScheduleData.contractingAccountName,
          value: parsedScheduleData.contractingAccountId
        });
      }
    }
    if (this.selectedCompanyId && parsedScheduleData.accountId === this.selectedCompanyId) {
      this.formSelectValueAccounts[j].value.selectedChildOptions.push(parsedScheduleData.contractingAccountId);
      this.selectedCompany = this.formSelectValueAccounts[j];
    }
    return parsedScheduleData;
  }

  private b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || 'application/pdf';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  private formatToday(): string {
    const today = new Date();
    return this.datePipe.transform(today, 'yyyyMMdd');
  }

  private prepareData() {
    const currentUserEmail = this.loggedInUser.email;
    this.etreeService.getOperationUser(this.currentCompany.id).subscribe(
      (response: any[]) => {
        this.particpantsItemForJira = response.map(user => ({
          label: user.username,
          value: user.email,
          id: user.id,
          disabled: user.email === currentUserEmail
        }));
        this.particpantsItemForJira = _.sortBy(this.particpantsItemForJira, ['label']);
        this.selectedParticipantForJira = this.particpantsItemForJira
          .filter(user => user.disabled)
          .map(user => user.value);
      },
      () => {
        this.error = true;
      }
    );
  }

  getClassForCategory(announcementCategory: any) {
    return this.utilsService.getClassForAnnouncementCategory(announcementCategory);
  }

  getLabelFromAnnouncementCategory(announcementCategory: any) {
    if (announcementCategory === 'client_action_required') {
      return 'Client action required';
    }
    if (announcementCategory === 'emergency_maintenance') {
      return 'Emergency maintenance';
    }
    if (announcementCategory === 'scheduled_maintenance') {
      return 'Scheduled maintenance';
    }
    if (announcementCategory === 'service_change') {
      return 'Service change';
    }
    if (announcementCategory === 'marketing') {
      return 'Marketing';
    }
    return 'Announcement';
  }
}
